module.exports = __webpack_public_path__ + "img/twitter_w.a04ce586.svg";